/**
 * RivalScouts.tsx
 * Display ghost rivals who are scouting/targeting a player or prop
 * 
 * Single Responsibility: Render rival avatars and action text
 * Props In: rivals (array of names), action (string)
 * Events Out: none
 * 
 * Reference: TunnelMockupsV5_Final.jsx lines 95-118
 * Note: GR-1 implementation - derived data only, no backend calls
 */
import React from 'react';

interface RivalScoutsProps {
  rivals: string[];
  action?: 'scouting' | 'targeting';
}

export const RivalScouts: React.FC<RivalScoutsProps> = ({ 
  rivals, 
  action = 'scouting' 
}) => {
  if (!rivals || rivals.length === 0) return null;
  
  const displayNames = rivals.length <= 2 
    ? rivals.join(' & ') 
    : `${rivals[0]} +${rivals.length - 1}`;
  
  return (
    <div className="flex items-center gap-2 text-[11px]">
      <div className="flex -space-x-1.5">
        {rivals.slice(0, 2).map((name) => (
          <div 
            key={name}
            className="w-5 h-5 rounded-full bg-slate-700 border-2 border-slate-800 flex items-center justify-center"
          >
            <span className="text-[9px] font-bold text-slate-300">
              {name[0].toUpperCase()}
            </span>
          </div>
        ))}
      </div>
      <span className="text-slate-500">{displayNames} {action}</span>
    </div>
  );
};

export default RivalScouts;
